// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_HsM","rootNoMargin":"styles_rootNoMargin__3NtdZ"};